import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {Skeleton} from "@mui/material";

import {designColors} from "~/ui";

interface BmLayoutSkeletonProps {
  maxWidth?: string;
  sections?: number[]; // Number of skeletons in each section
}

export const BmLayoutSkeleton: React.FC<BmLayoutSkeletonProps> = ({maxWidth = "100%", sections = [3, 3, 2]}) => {
  return (
    <Box maxWidth={maxWidth}>
      <Box mb="50px">
        <Skeleton variant="rounded" height={35} sx={{borderRadius: 2, backgroundColor: designColors.grey_7}} />
      </Box>
      {sections.map((skeletonCount, sectionIndex) => (
        <Stack key={sectionIndex} mb="30px" spacing={1}>
          {Array.from({length: skeletonCount}).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              height={35}
              sx={{borderRadius: 2, backgroundColor: designColors.grey_7}}
            />
          ))}
        </Stack>
      ))}
    </Box>
  );
};
